import { app } from '../../../app';
import { Controller } from './software-license-management.controller';

app.component('companySoftwareLicenseManagement', {
    controller: Controller,
    templateUrl: require('./software-license-management.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/software-license-management/software-license-management.component.js